import { render, staticRenderFns } from "./co-notifications-preferences.vue?vue&type=template&id=47db60ca&"
import script from "./co-notifications-preferences.vue?vue&type=script&lang=ts&"
export * from "./co-notifications-preferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports